import {
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	EventEmitter,
	forwardRef,
	HostBinding,
	Input,
	Output,
	TemplateRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from "@angular/forms";

const SELECT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => ChipAutocompleteFormComponent),
	multi: true,
};

@Component({
	selector: "ic-chip-autocomplete-form",
	templateUrl: "./chip-autocomplete-form.component.html",
	styleUrls: ["./chip-autocomplete-form.component.scss"],
	providers: [SELECT_CONTROL_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChipAutocompleteFormComponent implements ControlValueAccessor {
	selectedItems: any[] = [];
	autoCompleteControl = new UntypedFormControl();

	@Input() icon: string;
	@Input() iconRight: boolean;
	@Input() placeholder: string;
	@Input() label: string;
	@Input() key: string;
	@Input() items: any[] = [];
	@Input() loading = false;
	@Input() error = false;

	@Output() autocomplete = new EventEmitter<string>();

	@ContentChild("itemTemplate", { static: false }) itemTemplate: TemplateRef<any>;
	@ContentChild("selectedTemplate", { static: false }) selectedTemplate: TemplateRef<any>;
	@ContentChild("errorTmpl", { static: false }) errorTmpl: TemplateRef<any>;

	@HostBinding("class.disabled") disabled = false;

	@Input() disableClickHandler: (item) => boolean = () => false;

	inputChanged(event) {
		this.autocomplete.emit(event);
	}

	itemAdded(event) {
		this.selectedItems.push(event);
		this.autoCompleteControl.reset();

		this.onTouch();
		this.onChange(this.selectedItems);
	}

	itemRemoved(index: number) {
		this.selectedItems = [...this.selectedItems.slice(0, index), ...this.selectedItems.slice(index + 1)];

		this.onTouch();
		this.onChange(this.selectedItems);
	}

	writeValue(value: any): void {
		if (Array.isArray(value)) {
			this.selectedItems = value;
		}
	}

	registerOnChange(fn: (v: unknown) => void) {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
		this.autoCompleteControl.disable();
	}

	// Bind control functions.
	private onTouch = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
	private onChange = (_: unknown) => {}; // eslint-disable-line @typescript-eslint/no-empty-function
}
